<template>
  <div class="app-activate-auto-top-up">
    <div class="text"><slot name="txtBeforeAutoTopUp"></slot></div>
      <b-form
        class="change-auto-top-up-form"
        :id="'form' + _uid"
        :novalidate="true">
          <b-form-radio-group  required
                               class="top-up-group"
                               v-model="splittedTopUp"
          >
            <auto-top-up
              :top-up="topUp_"
              :trigger.sync="topUp_.trigger"
              :amount.sync="topUp_.amount"
              :monthly-value="monthlyValue"
              :amounts="amounts"
            >
              <template v-for="slot in possibleChildSlotsFor('AutoTopUp')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </auto-top-up>
          </b-form-radio-group>
      </b-form>
    <PaymentInformation :payment="payment">
      <template v-for="slot in possibleChildSlotsFor('Payment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PaymentInformation>
    <Stepper
      @prev="goBack()"
      @next="activate()"
      :loading-next="loading"
      :disabled-next="$v.$invalid || loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import AutoTopUp from './AutoTopUp.vue'
import processSteps from '@/mixins/processSteps'
import isValid from '@/mixins/isValid'
import { required, numeric, minLength, maxLength, minValue, maxValue } from 'vuelidate/lib/validators'
import { mapActions, mapMutations } from 'vuex'
import { stepName as nextProcessStep } from '@/components/process/generic/TopUp/ChangeAutoTopUp/bild/Success.vue'
import syncProperty from '@/mixins/syncProperty'
import slotProxy from '@/mixins/slotProxy'
import PaymentInformation from '@/components/process/generic/Payment/PaymentInformation.vue'
import Stepper from '@/components/generic/Stepper.vue'

export const stepName = 'activate'

export default {
  name: 'ActivateAutoTopUp',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    splittedTopUp: {
      get: function () {
        if (this.topUp_.type === 'monthly') {
          return {
            type: this.topUp_.type,
            trigger: this.topUp_.trigger
          }
        }
        return {
          type: this.topUp_.type
        }
      },
      set: function (value) {
        this.topUp_.type = value.type
        if (value.type === 'monthly') {
          this.topUp_.trigger = value.trigger
        }
      }
    }
  },
  mixins: [
    syncProperty('topUp', 'topUp_'),
    validationMixin,
    isValid,
    processSteps(stepName, stepName, nextProcessStep),
    slotProxy()
  ],
  validations () {
    return {
      topUp: {
        amount: {
          required,
          numeric,
          minLength: minLength(this.amounts.minLength),
          naxLength: maxLength(this.amounts.maxLength),
          minValue: minValue(this.amounts.minValue),
          maxValue: maxValue(this.amounts.maxValue)
        },
        type: {
          required
        }
      }
    }
  },
  components: { AutoTopUp, PaymentInformation, Stepper },
  methods: {
    activate () {
      this.loading = true
      this.changeAutoTopUp({ topUpData: this.topUp_, amount: this.topUp_.amount * 100, nextStep: this.nextStep }).then(() => {
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    ...mapActions('topUp', [
      'changeAutoTopUp'
    ]),
    ...mapMutations('topUp', [
      'setCurrentView', 'setActivationView'
    ]),
    goBack () {
      this.setCurrentView('default')
    }
  },
  props: {
    monthlyValue: {
      type: Array
    },
    payment: {
      type: Object,
      required: true
    },
    paymentType: {
      type: Boolean,
      required: false
    },
    amounts: {
      type: Object,
      default: function () {
        return {
          minLength: 2,
          maxLength: 2,
          minValue: 10,
          maxValue: 40
        }
      }
    }
  }
}
</script>
